// Primes spéciales exonérées gérées via des champs dédiés (plafonds d'exonération)
// Plafonds FIXES : le surplus au-delà du plafond est ajouté au brut imposable IS et au brut social
const SPECIAL_PRIME_PLAFONDS = {
  prime_panier: 1298,
  prime_salissure: 5629,
  prime_tenue: 3031,
  prime_outillage: 4330
};

const SPECIAL_EXEMPT_PRIMES = [
  { field: 'prime_panier', label: 'Prime de panier', plafond: SPECIAL_PRIME_PLAFONDS.prime_panier },
  { field: 'prime_salissure', label: 'Prime mensuelle de salissure', plafond: SPECIAL_PRIME_PLAFONDS.prime_salissure },
  { field: 'prime_tenue', label: 'Indemnité mensuelle de tenue de travail', plafond: SPECIAL_PRIME_PLAFONDS.prime_tenue },
  { field: 'prime_outillage', label: "Prime mensuelle d'outillage", plafond: SPECIAL_PRIME_PLAFONDS.prime_outillage }
];

const getSpecialPrimeField = (name) => {
  const n = (name || '').toLowerCase();
  if (n.includes('panier')) return 'prime_panier';
  if (n.includes('salissure')) return 'prime_salissure';
  if (n.includes('tenue de travail')) return 'prime_tenue';
  if (n.includes('outillage')) return 'prime_outillage';
  return null;
};

export { SPECIAL_PRIME_PLAFONDS, SPECIAL_EXEMPT_PRIMES, getSpecialPrimeField };
